import type {
  HandleGetNewCode,
  SetRequestStatus,
} from 'src/components/AuthNew/types';
import { RequestStatus } from 'src/components/AuthNew/types';
import { flowAsync } from 'src/utils/fp';
import {
  changeNameOrSureNameOrEmail,
  ifEmailWasChanged,
  ifNameOrSureNameOrEmailWasChanged,
  ifPhoneAndEmailNotChanged,
  ifPhoneWasChanged,
  postClientUpdate,
} from 'checkout/components/Client/utils';
import type { CLIENT, FullClientData } from '@lt/api/dist/types/client';
import type {
  SetEmailWasChanged,
  SetNewPhone,
} from 'checkout/components/Client/types';

type Props = {
  clientAuthToken?: string;
  setRequestStatus: SetRequestStatus;
  setClientInfo: (client: FullClientData) => void;
  handleGetNewCode: HandleGetNewCode;
  openConfirmationPhone: () => void;
  openMailConfirmation: () => void;
  setNewPhone: SetNewPhone;
  confirmClient(clientData: CLIENT): void;
  setEmailWasChanged: SetEmailWasChanged;
  clientData: CLIENT | null;
  openShortForm?: () => void;
};

export const useUpdateClient = ({
  setRequestStatus,
  clientAuthToken,
  setClientInfo,
  handleGetNewCode,
  openConfirmationPhone,
  openMailConfirmation,
  setNewPhone,
  confirmClient,
  setEmailWasChanged,
  clientData,
  openShortForm,
}: Props) => {
  /** @desc обновление данных клиента и переход к данным о туристах */
  const submitUpdateClient = async (data): Promise<void> => {
    setRequestStatus(RequestStatus.Submitting);

    try {
      await flowAsync(
        /** @desc если имя, фамилия или почта были изменены,
         * то выполнится /client/update и обновит данные
         *  */
        changeNameOrSureNameOrEmail(
          ifNameOrSureNameOrEmailWasChanged(clientAuthToken)(postClientUpdate)(
            setClientInfo,
          ),
        ),
        /** @des если телефон был изменен, запросим код подтверждения
         * и откроем окно ввода кода
         * */
        ifPhoneWasChanged(handleGetNewCode)(openConfirmationPhone)(setNewPhone),
        /** @desc если телефон и почта небыли изменены, то просто перейдем к вводу данных о туристах */
        ifPhoneAndEmailNotChanged(confirmClient, openShortForm),
        /** @desc если почта была изменена, то установится флаг,
         * это нужно для вывода уведомления о том что почта была изменена
         *  */
        ifEmailWasChanged(setEmailWasChanged)(openMailConfirmation),
      )([clientData, data.client]);
      setRequestStatus(RequestStatus.Idle);
      return undefined;
    } catch (error) {
      console.dir(error);
      setRequestStatus(RequestStatus.Failed);

      throw error;
    }
  };

  return {
    submitUpdateClient,
  };
};
